import axios from "axios";

// Configs
import config from "../config";

// Services
import auth from "./auth/auth";
import sessionStorage from "./storage/SessionStorage";

class FileConnector {
	constructor() {
		axios.defaults.baseURL = config.BACKEND_API_URL;
		axios.defaults.timeout = 180000;
	}

	handleErrors(error) {
		if (error.response) {
			if ([400, 404, 422, 403].includes(error.response.status)) {
				if (error.response.data.error?.type === "disclaimer_error") {
					let authObj = JSON.parse(sessionStorage.getPathName("authObj"));
					authObj["disclaimer_log"] = false;
					sessionStorage.setPathName("authObj", JSON.stringify(authObj));
					window.location.href = "/disclaimer";
				}
				return {
					error: error.response.data.error || error.response.data.error?.message || "Data Not Found",
					status: error.response.status,
				};
			}
			if (error.response.status === 401) {
				sessionStorage.setItem("authObj", null);
				window.location.href = "/login";
				return {
					error: error.response.data.error.message || "Unauthorized",
					error_type: error.response.data.error.type,
					status: error.response.status,
				};
			}
			if (error.response.status === 500) return { error: "Server error", status: error.response.status };
		} else {
			return { error: "Connection Error" };
		}
	}

	setDefaultHeaders() {
		const defaultHeaders = {
			"Content-Type": "application/json; charset=UTF-8",
		};
		if (auth.isAuth()) {
			defaultHeaders["Authorization"] = `Bearer ${auth?.getTokens()?.access_token}`;
		}
		return defaultHeaders;
	}

	async downloadFilesPost(config) {
		const optimized_config = {
			url: config?.url,
			method: "post",
			headers: { ...this.setDefaultHeaders(config), ...config?.headers },
			params: config?.params,
			data: config?.data,
			responseType: "arraybuffer",
		};

		try {
			const res = await axios.request(optimized_config);
			return res;
		} catch (error) {
			if (axios.isCancel(error)) {
				return { canceled: true };
			} else return this.handleErrors(error);
		}
	}
}
export default new FileConnector();
